// This is the landing page for the Inspection Module - i.e., we land here when the user clicks "Inspection Module" from the home page
// it checks if the user is authenticated
// If authenticated, redirects to the appropriate dashboard based on role
// If not authenticated, shows options to login or register
import React from 'react';
import { Container, Card, Row, Col, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const InspectionModule = () => {
  const navigate = useNavigate();
  const { isAuthenticated, user, loading } = useAuth();

  React.useEffect(() => {
    if (isAuthenticated && user) {
      // Redirect to appropriate dashboard based on role
      const role = user.role.toLowerCase(); // Ensure lowercase
      navigate(`/dashboard/${role}`);
    }
  }, [isAuthenticated, user, navigate]);

  // Show loading spinner while checking authentication
  if (loading) {
    return (
      <Container className="mt-5 text-center">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </Container>
    );
  }

  // If authenticated, return null (will redirect in useEffect)
  if (isAuthenticated && user) {
    return null;
  }

  return (
    <Container className="mt-5">
      {/* Home Navigation */}
      <div className="mb-4">
        <Button
          variant="outline-primary"
          onClick={() => navigate('/')}
          className="d-flex align-items-center"
        >
          <i className="fas fa-home me-2"></i>
          Back to Home
        </Button>
      </div>

      <div className="text-center mb-5">
        <h1 className="display-4 text-primary">Inspection Module</h1>
        <p className="lead">Equipment Inspection and Certification System</p>
      </div>

      <Row className="justify-content-center">
        <Col md={8} lg={6}>
          <Card className="shadow">
            <Card.Body className="p-5">
              <div className="text-center mb-4">
                <i className="fas fa-user-shield text-primary" style={{ fontSize: '3rem' }}></i>
              </div>
              <h3 className="text-center mb-4">Access Required</h3>
              <p className="text-center text-muted mb-4">
                Please login or register to access the inspection system.
              </p>
              <div className="d-grid gap-2">
                <Button
                  variant="primary"
                  size="lg"
                  onClick={() => navigate('/login')}
                >
                  Login
                </Button>
                <Button
                  variant="outline-primary"
                  size="lg"
                  onClick={() => navigate('/register')}
                >
                  Register
                </Button>
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default InspectionModule;
